import { apiClient } from '@/libs/api'
import { type ShipmentOrdersFormValues } from '@/routes/_protected/$tenantKey/shipment-orders/-models/shipment-orders-form-values'

export type UpdateShipmentOrdersQuery = {
  tenantKey: string
  dto: ShipmentOrdersFormValues
}

export const updateShipmentOrders = async ({
  tenantKey,
  dto
}: UpdateShipmentOrdersQuery): Promise<boolean> => {
  await apiClient._tenant(tenantKey).shipment_orders.$put({
    body: dto
  })
  return true
}
